

























import { Component, Vue, Prop } from 'vue-property-decorator';
import http from '@/services/Http';
import { YoutubeVideo } from '@/models/Youtube';
import { websiteText } from '@/mixins/websiteTexts';
import YoutubePopup from './YoutubePopup.vue';

@Component({
    components: {
        YoutubePopup
    }
})

class YoutubePlaylist extends Vue {
    @Prop() playlistId!: string;
    public websiteText = websiteText;

    public videos: YoutubeVideo[] = [];
    
    public created() {
        this.fetchPlaylist();
    }

    public fetchPlaylist() {
            http.get(`/api/youtube/playlist/${this.playlistId}`)
                .then((response: any) => response.json())
            .then((data: YoutubeVideo[]) => {
                this.videos = data;
            })
            .catch((e: any) => {
                console.error('Failed to fetch playlist:', e);
            });
    }

    public showVideo(videoUrl: string, videoTitle: string) {
        this.$modal.show(
            YoutubePopup,
            {
                youtubeUrl: videoUrl,
                youtubeTitle: videoTitle
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
    }
}

export default YoutubePlaylist;
